import {
    CREATE_LOBBY,
    FETCH_LOBBIES,
    FETCH_LOBBY,
    FETCH_LOBBY_TRANSACTION,
    LIST_LOBBIES,
    LIST_LOBBY_TRANSACTION,
    SHOW_LOBBY,
    UPDATE_LOBBY
} from "./types";

const iniPaging = {
    page: 1,
    totals: 0,
    size: 25,
};

const init = {
    ...iniPaging,
    isLoading: true,
    list: [],
    active: {
        lobby: {},
        isLoading: true
    },
    transaction: {
        list: [],
        isLoading: true,
        filter: {},
        ...iniPaging
    }
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_LOBBIES:
            return {
                ...state,
                isLoading: true
            };
        case LIST_LOBBIES:
            return {
                ...state,
                ...payload,
                list: payload.list || [],
                isLoading: false
            };
        case FETCH_LOBBY:
            return {
                ...state,
                active: {
                    lobby: {},
                    isLoading: true
                }
            };
        case SHOW_LOBBY:
            return {
                ...state,
                active: {
                    lobby: payload || {},
                    isLoading: false
                }
            };
        case CREATE_LOBBY:
        case UPDATE_LOBBY:
            return {
                ...state,
                isLoading: true
            };
        case FETCH_LOBBY_TRANSACTION:
            return {
                ...state,
                transaction: {
                    ...state.transaction,
                    list: [],
                    filter: payload,
                    isLoading: true
                }
            };
        case LIST_LOBBY_TRANSACTION:
            return {
                ...state,
                transaction: {
                    ...state.transaction,
                    list: payload.data || [],
                    isLoading: false,
                    ...payload.paging
                }
            }
        default:
            return state;
    }
};
